import { render, staticRenderFns } from "./ProjectSummaryView.vue?vue&type=template&id=ed01658c&scoped=true&"
import script from "./ProjectSummaryView.vue?vue&type=script&lang=js&"
export * from "./ProjectSummaryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed01658c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCardText,VCardTitle,VLayout})
